import React, { useEffect, useState } from "react";
import "boxicons/css/boxicons.min.css";
import api from "../Authentication/authService";
import { useDispatch, useSelector } from "react-redux";
import { Link, useLocation } from "react-router-dom";
import "../../custom.css";
import PaymentPlansSkeleton from "../Skeleton/PaymentPlanSkeleton";
import Swal from "sweetalert2";
import withReactContent from "sweetalert2-react-content";
import { PaymentStatus } from "../../context/PaymentStatusSlice";
import { CONFIG } from "../../config";
import { FocusTrap } from "focus-trap-react";
import Toast from "../../Toast/Toast";

export default function PaymentPlans() {
  const [toast ,setToast] = useState(null);
  const [expandedPlans, setExpandedPlans] = useState(false);
  const [loading, setLoading] = useState(true);
  const [planData, setPlanData] = useState([]);
  const [planHistory, setPlanHistory] = useState([]);

  const [totalAmountSchedule, setTotalAmountSchedule] = useState(0);
  const [amountPaid, setAmountPaid] = useState(0);
  const [noOfPayments, setNoOfPayments] = useState(0);
  const [successPayments, setSuccessPayments] = useState(0);
  const [nextPaymentDate, setNextPaymentDate] = useState(null);
  const [isDeleteModalOpen, setIsDeleteModalOpen] = useState(false);
  const location = useLocation();
  const apiUrl = CONFIG.REACT_APP_API_BASE_URL;
  const dispatch = useDispatch();
  const [activeTab, setActiveTab] = useState("active");
  const [activePlanCount, setActivePlanCount] = useState(0);
  const [historyPlanCount, setHistoryPlanCount] = useState(0);
  const { CredenceAccountNumber } = useSelector(
    (state) => state.Authentication,
  );

  const togglePlan = () => setExpandedPlans((prev) => !prev);
  const MySwal = withReactContent(Swal);
  const [expandedPlanIndex, setExpandedPlanIndex] = useState(null);
  const [refresh, setRefresh] = useState(false);

  const handlePlanToggle = (index) => {
    setExpandedPlanIndex(expandedPlanIndex === index ? null : index);
  };

  const formatDate = (dateStr) => {
    if (!dateStr || typeof dateStr !== "string") return "N/A";

    const parts = dateStr.split("/");
    if (parts.length !== 3) return dateStr;

    const [day, month, year] = parts;
    const date = new Date(`${year}-${month}-${day}`);

    return isNaN(date)
      ? "N/A"
      : date.toLocaleDateString("en-US", {
          month: "short",
          day: "numeric",
          year: "numeric",
        });
  };
  const convertTimestampToDate = (timestamp) => {
    if (!timestamp) return "N/A";

    const date = new Date(timestamp);

    // Format: MM/DD/YYYY
    const month = (date.getMonth() + 1).toString().padStart(2, "0");
    const day = date.getDate().toString().padStart(2, "0");
    const year = date.getFullYear();

    return `${month}/${day}/${year}`;
  };


  const isActiveSchedule = (item) => {
    if (item.status === "SCHEDULED") return true;
    return false;
  };

  const isCompletedSchedule = (item) => {
    if (
      ["APPROVAL", "CAPTURED", "SETTLED"].includes(item.status)
    )
      return true;
    return false;
  };

  const formatPlans = (data) => {
    //console.log('history data',data)
  const formatDate = (date) => {
    const d = new Date(date);
    const mm = String(d.getMonth() + 1).padStart(2, "0");
    const dd = String(d.getDate()).padStart(2, "0");
    const yyyy = d.getFullYear();
    return `${mm}/${dd}/${yyyy}`;
  };

  const grouped = {};

  data.forEach((item) => {
    if (!grouped[item.planID]) {
      grouped[item.planID] = { id: `PLN${item.planID}`, schedules: [] };
    }

    grouped[item.planID].schedules.push({
      date: item.date,
      timestamp: new Date(item.dateTimestamp), 
      amount: item.scheduledAmount,
      status: item.status,
      paymentMethod: item.paymentMethod,
    });
  });

  return Object.values(grouped).map((plan) => {
    const sorted = plan.schedules.sort(
      (a, b) => a.timestamp - b.timestamp
    );

    const planStatus = sorted.every(isCompletedSchedule)
      ? "completed"
      : "cancelled";

    return {
      id: plan.id,
      planStatus,
      startDate: sorted[0].date,
      endDate: sorted[sorted.length - 1].date,
      schedules: sorted.map(({ date, amount, status }) => ({
        date,
        amount,
        status,
      })),
    };
  });
};
const handleDelete = async (planID) => {
  const hasInProcessPlan = planData?.some((p) => p.status === "SCHEDULED");

  if (!hasInProcessPlan) {
    setIsDeleteModalOpen(false);

    setToast({
      type: "warning",
      message: "No future transaction to cancel.",
    });

    return;
  }

  try {
    setLoading(true);

    const response = await api.delete(
      `${apiUrl}/SchedulePaymentPlan?PlanID=${planID}`
    );

    if (response.status === 200) {
      const res = await api.get(
        `${apiUrl}/SchedulePaymentPlan?CredenceAccountNumber=${CredenceAccountNumber}`
      );

      if (res.status === 200) {
        setRefresh((prev) => !prev);
        setPlanData(res?.data?.result || []);
        setIsDeleteModalOpen(false);

        if (res?.data?.result?.length > 0) {
          dispatch(
            PaymentStatus({
              paymentPlanStatus: "",
            })
          );
        }

        setToast({
          type: "success",
          message: "Payment plan deleted successfully.",
        });
      }
    }
  } catch (err) {
    setToast({
      type: "error",
      message: "Something went wrong while deleting the payment plan.",
    });
  } finally {
    setLoading(false);
  }
};

  const getRowClass = (status) => {
    switch (status) {
      case "Paid":
        return "payment-completed";
      case "Scheduled":
        return "payment-upcoming";
      case "In-Progress":
        return "payment-upcoming";
      case "Failed":
        return "payment-failed";
      default:
        return "";
    }
  };

  const getBadgeClass = (status) => {
    switch (status) {
      case "Paid":
        return "status-badge status-completed";
      case "Scheduled":
        return "status-badge status-scheduled";
      case "In-Progress":
        return "status-badge status-pending";
      case "Failed":
        return "status-badge status-cancelled";
      default:
        return "status-badge";
    }
  };
  const handleDeleteModal = () => {
    setIsDeleteModalOpen(true);
  };
  const formatStatus = (status) =>
  status
    ? status.charAt(0).toUpperCase() + status.slice(1).toLowerCase()
    : "";
  const isPaymentCompleted = (p) =>
    (["APPROVAL", "CAPTURED", "SETTLED"].includes(p.status) 
     ) ;

  useEffect(() => {
    if (!CredenceAccountNumber) return;
    setLoading(true);

    const fetchData = async () => {
      try {
        const res = await api.get(
          `${apiUrl}/SchedulePaymentPlan?CredenceAccountNumber=${CredenceAccountNumber}`,
        );
        // console.log("API response:", res.data);
        const rawData = Array.isArray(res?.data) ? res?.data : [];

        const data = rawData.map((item) => {
          let timestamp = item.dateTimestamp;

          if (!timestamp && item.date) {
            const [day, month, year] = item.date.split("/");
            timestamp = new Date(`${year}-${month}-${day}`).getTime();
          }

          return {
            ...item,
            dateTimestamp: timestamp,
          };
        });
        // console.log(res.data);
        const groupedByPlan = Object.values(
          data.reduce((acc, item) => {
            if (!acc[item.planID]) acc[item.planID] = [];
            acc[item.planID].push(item);
            return acc;
          }, {}),
        );

        const active = [];
        const history = [];

        groupedByPlan.forEach((planSchedules) => {

          const hasActive = planSchedules.some(isActiveSchedule);

          if (hasActive) {
            active.push(...planSchedules);
          } else {
            history.push(...planSchedules);
            // console.log(history)
          }
        });
        setPlanData(active);
        // console.log('history',history)
        setPlanHistory(formatPlans(history));
        // console.log("History", formatPlans(history));
        // console.log("active", active);

        setNoOfPayments(active.length);

        const totalSchedule = active.reduce(
          (sum, p) => sum + Number(p.scheduledAmount || 0),
          0,
        );
        setTotalAmountSchedule(totalSchedule);

        const paidAmount = active
          .filter(isPaymentCompleted)
          .reduce((sum, p) => sum + Number(p.scheduledAmount || 0), 0);
        setAmountPaid(paidAmount);

        // setSuccessPayments(active.filter((p) => p.status === "Paid").length);
setSuccessPayments(
  active.filter((p) =>
    ["Approval", "Captured", "Settled"].includes(formatStatus(p.status))
  ).length
);
        const upcoming = data
          .filter(
            (p) =>
              p.dateTimestamp &&
              !["Paid", "Error", "Scheduled"].includes(p.status),
          )
          .sort((a, b) => a.dateTimestamp - b.dateTimestamp);

        setNextPaymentDate(upcoming[0] || null);
        //  activePlanCount = new Set(active.map(item => item.planID)).size;
        //   historyPlanCount = new Set(history.map(item => item.planID)).size;
        setActivePlanCount(new Set(active.map((item) => item.planID)).size);
        setHistoryPlanCount(new Set(history.map((item) => item.planID)).size);

        // console.log("Current", active);
        // console.log("History", history);
      } catch (error) {
        // console.error("Payment plan error:", error);
        setPlanData([]);
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, [CredenceAccountNumber, location, apiUrl,refresh]);

  const progressPercent =
    totalAmountSchedule > 0
      ? ((amountPaid / totalAmountSchedule) * 100).toFixed(2)
      : 0;

  return (
    <>
    {toast && (
  <Toast
    message={toast.message}
    type={toast.type}
    onClose={() => setToast(null)}
  />
)}
      {/* <ModuleNavbar />
      <Sidebar /> */}

        <main className="main-content">
          <div className="layout-container">
            <div className="layout-page">
             {loading ? (
  <PaymentPlansSkeleton />
) : (
  <>
    {/* HEADER */}
    <section className="plans-header-section">
      <div className="plans-header-content">
        <div className="plans-header-left">
          <h1 className="plans-page-title">Payment Plans</h1>
          <p className="plans-page-subtitle">
            Manage your payment arrangements and schedules
          </p>
        </div>
      </div>
    </section>

    {/* TABS */}
    <div className="plans-tabs">
      <button
        className={`plans-tab ${activeTab === "active" ? "active" : ""}`}
        onClick={() => setActiveTab("active")}
      >
        Active Plans
        <span className="tab-badge">{activePlanCount}</span>
      </button>

      <button
        className={`plans-tab ${activeTab === "history" ? "active" : ""}`}
        onClick={() => setActiveTab("history")}
      >
        Plan History
        <span className="tab-badge">{historyPlanCount}</span>
      </button>
    </div>

    {/* ACTIVE TAB */}
    {activeTab === "active" ? (
      planData.length > 0 ? (
        <section className="plans-content-section">
          <div className="plan-card">

            <div className="plan-card-header">
              <div className="plan-card-main">
                <div className="plan-status-indicator status-active"></div>

                <div className="plan-card-info">
                  <div className="plan-card-top">
                    <h3 className="plan-id">
                      Plan #PLN{planData[0]?.planID ?? "—"}
                    </h3>

                    <span className="plan-type-badge badge-installment">
                      {planData[0]?.paymentFrequency} Payment
                    </span>
                  </div>

                  <div className="plan-card-meta">
                    <span className="plan-meta-item">
                      <i className="bx bx-calendar"></i>
                      Created {planData[0]?.createdDate}
                    </span>
                  </div>
                </div>
              </div>

              <div className="plan-card-actions">
                <button
                  className="btn-plan-menu"
                  onClick={() => setIsDeleteModalOpen(true)}
                >
                  <i className="bx bx-trash" aria-hidden="true"></i>
                 <span className="visually-hidden">Delete Plan</span>
                  
                </button>
              </div>
            </div>

            {/* PROGRESS */}
            <div className="plan-card-body">
              <div className="plan-progress-section">
                <div className="progress-header">
                  <span className="progress-text">
                    ${amountPaid} of ${totalAmountSchedule.toFixed(2)} paid
                  </span>

                  <span className="progress-percentage">
                    {progressPercent}%
                  </span>
                </div>

                <div className="progress-bar-wrapper">
                  <div
                    className="progress-bar"
                    style={{ width: `${progressPercent}%` }}
                  ></div>
                </div>

                <div className="progress-footer">
                  <span className="progress-detail">
                    {successPayments} of {noOfPayments} payments completed
                  </span>

                  <span className="progress-detail">
                    {noOfPayments - successPayments} remaining
                  </span>
                </div>
              </div>
            </div>

            {/* TABLE */}
            <div className="plan-schedule-details">
               <div className="schedule-details-content">
                 <div className="details-section">
                                        <h3 className="details-title">Payment Schedule</h3>
              <div className="schedule-table-wrapper">
                <table className="schedule-table">
                  <thead>
                    <tr>
                      <th>Payment Date</th>
                      <th>Amount</th>
                      <th>Status</th>
                    </tr>
                  </thead>

                  <tbody>
                    {planData.map((plan, index) => (
                      <tr key={index}>
                        <td>{plan.date}</td>
                        <td>
                          $
                          {plan.scheduledAmount
                            ? plan.scheduledAmount.toFixed(2)
                            : 0}
                        </td>

                        <td>
                          <span className="status-label">
                            {plan.status ?? "N/A"}
                          </span>
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            </div>
 </div>
                            </div>
          </div>
        </section>
      ) : (
        <section className="empty-state-section">
          <div className="general-card empty-state-card">
            <div className="empty-state-content">
              <div className="empty-state-icon">
                <i className="bx bx-calendar-x"></i>
              </div>

              <h3 className="empty-state-title">
                No Active Payment Plans
              </h3>

              <p className="empty-state-text">
                You don't have any active payment arrangements at this time.
              </p>

              <Link to="/Payment" className="btn btn-primary">
                Create Payment Plan
              </Link>
            </div>
          </div>
        </section>
      )
    ) : planHistory.length > 0 ? (
      <section className="plans-content-section">

        {planHistory.map((plan, index) => (
          <div className="plan-card plan-card-history" key={plan.id}>

            <div className="plan-card-header">

              <div className="plan-card-main">
                <div
                  className={`plan-status-indicator status-${plan.planStatus}`}
                ></div>

                <div className="plan-card-info">
                  <div className="plan-card-top">
                    <h3 className="plan-id">Plan #{plan.id}</h3>

                    <span
                      className="status-label"
                    >
                      {plan.planStatus}
                    </span>
                  </div>

                  <div className="plan-card-meta">
                    <span className="plan-meta-item">
                      <i className="bx bx-calendar"></i>
                      {plan.startDate} - {plan.endDate}
                    </span>
                  </div>
                </div>
              </div>

              <div className="plan-card-actions">
                <button
                  className="btn-plan-expand"
                  onClick={() => handlePlanToggle(index)}
                  aria-label="Show Payment Schedule"
                >
                  <i className="bx bx-chevron-down"></i>
                </button>
              </div>

            </div>

            {expandedPlanIndex === index && (
              <div className="plan-schedule-details">
                   <div className="schedule-details-content">
                    <div className="details-section">
                                        <h5 className="details-title">Payment Schedule</h5>
                                        <div className="schedule-table-wrapper">
                <table className="schedule-table">
                  <thead>
                    <tr>
                      <th>Payment Date</th>
                      <th>Amount</th>
                      <th>Status</th>
                    </tr>
                  </thead>

                  <tbody>
                    {plan.schedules.map((schedule, i) => (
                      <tr key={i}>
                        <td>{schedule.date}</td>
                        <td>${schedule.amount}</td>

                        <td>
                          <span className="status-label">
                            {schedule.status.toUpperCase()}
                          </span>
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
                </div>
                </div>
                </div>

              </div>
            )}

          </div>
        ))}

      </section>
    ) : (
      <section className="empty-state-section">
        <div className="general-card empty-state-card">
          <div className="empty-state-content">

            <div className="empty-state-icon">
              <i className="bx bx-calendar-x"></i>
            </div>

            <h3 className="empty-state-title">No Plan History</h3>

            <p className="empty-state-text">
              You don't have any completed or cancelled plans yet.
            </p>

          </div>
        </div>
      </section>
    )}
  </>
)}
            </div>
          </div>
        </main>
   

      {isDeleteModalOpen && (
        <div
          className="modal show"
          id="stopPlanModal"
          style={{
            display: "block",
            position: "fixed",
            top: 0,
            left: 0,
            width: "100%",
            height: "100%",
            backgroundColor: "rgba(0, 0, 0, 0.5)",
            zIndex: 1501,
          }}
        >
          <FocusTrap
  focusTrapOptions={{
    escapeDeactivates: false,
    initialFocus: false
  }}
>
          <div className="modal-dialog modal-dialog-centered">
            <div className="modal-content">
              <div className="modal-header">
                <h5 className="mb-0">Cancel Payment Plan?</h5>
                <button type="button" aria-label="to close popup" className="btn-close" data-bs-dismiss="modal"
                onClick={() => setIsDeleteModalOpen(false)}
                />
              </div>

              <div className="modal-body">
                <div className="modal-warning-box">
                  <strong>
                    <i className="bx bx-info-circle me-2"></i>
                    This action will:
                  </strong>
                  <ul>
                    <li>Cancel all future scheduled payments</li>
                    <li>Keep your remaining balance due</li>
                    <li>You can create a new plan later</li>
                  </ul>
                </div>
              </div>

              <div className="modal-footer">
                {/* <button
                  type="button"
                  className="btn btn-outline"
                  onClick={() => setIsDeleteModalOpen(false)}
                >
                  Cancel
                </button> */}
                <button
                  type="button"
                  className="btn btn-danger"
                  onClick={() => handleDelete(planData[0]?.planID)}
                >
                  Cancel Plan
                </button>
              </div>
            </div>
          </div>
          </FocusTrap>
        </div>
      )}
    </>
  );
}
